var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnCloseSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.99997 6.17501L2.46265 1.6377L1.6377 2.46265L6.17501 6.99997L1.63778 11.5372L2.46274 12.3621L6.99996 7.82492L11.5372 12.3621L12.3621 11.5372L7.82492 6.99996L12.3622 2.46265L11.5373 1.6377L6.99997 6.17501Z",
    fill: "#2D72FE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnCloseSmall);
export default __webpack_public_path__ + "static/media/icn_close_small.8338e8d2a123c357da74ff4f79efa213.svg";
export { ForwardRef as ReactComponent };